import useMergeSubitems from "api/api-hooks/subitems/useMergeSubitems";
import MergeItemsDrawer from "components/Drawers/MergeItemsDrawer";

const MergeSubitemsDrawer = ({
  open,
  onClose,
  selectedSubitems,
  module,
  fieldSchema,
  parentRecord,
  onMerge,
  fieldMap,
  createMode = false,
  onSaveCreate,
}) => {
  const { mergeSubitems, mergingSubitems, mergeSubitemsError } =
    useMergeSubitems();

  return (
    <MergeItemsDrawer
      open={open}
      onClose={onClose}
      fieldMap={fieldMap}
      onMerge={({ moduleAPIName, payload, onSuccess }) => {
        const finalPayload = {
          Action: "Merge",
          SubitemAPIName: fieldSchema.APIName,
          ParentRecordID: parentRecord.id,
          Data: payload,
        };
        if (createMode) {
          return onSaveCreate(payload);
        }

        mergeSubitems({
          moduleAPIName: moduleAPIName,
          payload: finalPayload,
          onSuccess: () => {
            onMerge();
            onSuccess();
          },
        });
      }}
      module={module}
      itemOne={selectedSubitems[0]}
      itemTwo={selectedSubitems[1]}
      loading={false}
      submitting={mergingSubitems}
      error={mergeSubitemsError}
      isSubitemMerge
    />
  );
};

export default MergeSubitemsDrawer;
